<template>
<div>
  <top-nav></top-nav>

  <submit ref="submit" v-model="submitVisible"></submit>

  <el-row class="submit-area">
    <el-col :xs="{span:22,offset:1}" :sm="{span:16,offset:4}" :md="{span:14,offset:7}" :lg="{span:12,offset:6}" class="submit-area-content">
      <div class="submit-area-title">
        Explore Allostery
      </div>

      <div class="submit-area-subtitle">
        Identify allosteric sites and pathways
      </div>

      <el-row class="submit-area-buttons">
        <el-col :span="6" class="submit-area-button" @click.native="$refs.submit.predictSites()">
          <div class="submit-area-button-img"><img src="../assets/predict-sites.png"></div>
          <div class="submit-area-button-name">Predict Allosteric Sites based on Active Site</div>
        </el-col>

        <el-col :span="6" :offset="3" class="submit-area-button" @click.native="$refs.submit.identifyPathways()">
          <div class="submit-area-button-img"><img src="../assets/identify-pathways.png"></div>
          <div class="submit-area-button-name">Identify Allosteric Pathways and Critical Residues</div>
        </el-col>

        <!--
        <el-col :span="6" class="submit-area-button" @click.native="$refs.submit.perturbPathways()">
          <div class="submit-area-button-img"><img src="../assets/perturb-pathways.png"></div>
          <div class="submit-area-button-name">Perturb Allosteric Pathways</div>
        </el-col>
        -->

        <el-col :span="6" :offset="3" class="submit-area-button" @click.native="$refs.submit.predictCorrelations()">
          <div class="submit-area-button-img"><img src="../assets/predict-correlations.png"></div>
          <div class="submit-area-button-name">Predict Inter-Residue Allosteric Correlations</div>
        </el-col>
      </el-row>

    </el-col>
  </el-row>

  <el-row>
    <el-col :xs="{offset:1,span:22}" :sm="{offset:7,span:10}" class="intro">
      <div class="intro-title">What is Ohm?</div>
      <div class="intro-content">
        <div>
          <p>Allostery is a natural phenomenon in proteins whereby distal structural elements are dynamically coupled. The origins of the allosteric phenomenon are rooted in physical properties of inter-atomic interactions in heterogenous media. Protein sequences are heterogeneous and their corresponding structures represent a diverse range of forces between amino acids that shape their structures.
          <img style="float:right;width:250px;height:120px;margin:10px" src="../assets/ohm-intro.png">
          In proteins perturbations of amino acids will propagate non-uniformly throughout the structure: a residue that is stronger coupled to a neighbor, would be more affected by the perturbation of the neighbor.
          </p>
          <p>
          To map allosteric communications, we use percolation theory to identify connections throughout a protein and search for paths between any of its two sites. <b style="font-size:20px">Ohm</b> is the automated server for the percolation-inspired pathways mapping and visualization.
          </p>
        </div>

        <h4 id="cite">How to cite Ohm</h4>
        <p>If you use Ohm in your work, please cite:</p>
        <!-- how-to-cite:start papers=ohm,allostery_review -->
        <ol class="how-to-cite" style="margin:0;padding:0">
          <li style="border:1px solid color-mix(in srgb, currentColor 18%, transparent);border-radius:0.75rem;padding:0.75rem 1rem;line-height:1.6;margin:0 0 0.75rem;list-style:none">
            <span>Wang J, Jain A, McDonald LR, Gambogi C, Lee AL, Dokholyan NV. Mapping allosteric communications within individual proteins. <i>Nat Commun</i>. 2020;11(1):3862.</span>
            <span style="display:flex;flex-wrap:wrap;gap:0.25rem 1rem;margin-top:0.4rem;font-size:0.85em"><a style="color:inherit;text-decoration:underline;text-underline-offset:2px" href="https://doi.org/10.1038/s41467-020-17618-2" target="_blank" rel="noreferrer">doi:10.1038/s41467-020-17618-2</a> <a style="color:inherit;text-decoration:underline;text-underline-offset:2px" href="https://pubmed.ncbi.nlm.nih.gov/32737291/" target="_blank" rel="noreferrer">PubMed 32737291</a></span>
          </li>
          <li style="border:1px solid color-mix(in srgb, currentColor 18%, transparent);border-radius:0.75rem;padding:0.75rem 1rem;line-height:1.6;margin:0 0 0.75rem;list-style:none">
            <span>Dokholyan NV. Controlling allosteric networks in proteins. <i>Chem Rev</i>. 2016;116(11):6463-6487.</span>
            <span style="display:flex;flex-wrap:wrap;gap:0.25rem 1rem;margin-top:0.4rem;font-size:0.85em"><a style="color:inherit;text-decoration:underline;text-underline-offset:2px" href="https://doi.org/10.1021/acs.chemrev.5b00544" target="_blank" rel="noreferrer">doi:10.1021/acs.chemrev.5b00544</a> <a style="color:inherit;text-decoration:underline;text-underline-offset:2px" href="https://pubmed.ncbi.nlm.nih.gov/26894745/" target="_blank" rel="noreferrer">PubMed 26894745</a></span>
          </li>
        </ol>
        <!-- how-to-cite:end -->

        <div style="display:flex;flex-direction:column;align-items:center">
          <div style="width:150px;height:150px"><img style="width:100%;height:100%" src="../assets/qr-code.svg"></div>

          <div style="width:170px;height:50px">
            <img style="width:100%;height:100%" src="../assets/ohm-url.png">
          </div>
        </div>

      </div>
    </el-col>
  </el-row>

</div>
</template>

<script>
import { bus } from '../bus.js'
import axios from 'axios'
import TopNav from './TopNav.vue'
import Submit from './Submit.vue'
// import SearchStructure from './SearchStructure.vue'
// import DrawStructure from './DrawStructure.vue'
// import UploadStructure from './UploadStructure.vue'

export default {
  name: 'Home',

  data () {
    return {
      submitVisible: false,
//      searchStructureVisible: false,
//      drawStructureVisible: false,
//      uploadStructureVisible: false,
      showTypeContent: 0,
      taskType: -1,
      taskConfig: [
        {
          title: '',
          compound: '',
          smiles: '',
          database: ['CHEMBL'],
          fpType: 'FP2',
          simCutoff: 0.1,
          num: 100
        }, {
          title: '',
          simTime: 200000,
          repT: [0.200, 0.208, 0.214, 0.220, 0.225, 0.230, 0.235, 0.240],
          repInt: 2000,
          heatExchCoeff: 0.1
        }
      ],
      content: ''
    }
  },

  components: {
    TopNav,
    Submit
//    SearchStructure, DrawStructure, UploadStructure
  },

  computed: {
    frontConfig () {
      return this.$store.state.frontConfig
    }
  },

  methods: {
    redirect (url) {
      window.location.href = url
    },

    post (url, p, cb1 = () => {}, cb2 = () => {}) {
      let parts = [new Blob([JSON.stringify(p)], { type: 'application/json' })]
      let fileToSend = new File(parts, 'front-config.json', {
        type: 'application/json'
      })

      let formData = new FormData()

      formData.append('par', fileToSend)

      axios({
        method: 'post',
        url,
        data: formData,
        config: {headers: {'Content-Type': 'multipart/form-data'}},
        withCredentials: true
      }).then(response => {
        cb1(response)
//        console.log(response)
      }).catch(error => {
        cb2(error)
//        console.log(error.response)
      })
    }
  },

  mounted () {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "../styles/theme.scss";


.submit-title {
  border-bottom: 2px dotted #111111;
  font: normal bold 18px 'trebuchet ms', georgia, arial;
  color: $theme-color;
  margin-bottom:30px;
}

.submit-area {
  position: relative;
  background-color: $theme-color;
}

.submit-area-content {
  color: white;
  text-align: center;
}

.submit-area-title {
  font-size: 65px;
  font-weight: 200;
  margin-top: 20px;
}

.submit-area-subtitle {
  font-size: 24px;
  font-weight: 200;
  margin: 20px;
}

.submit-area-input {
}

.submit-area-input-button {
  font-size: 17px;
  cursor: pointer;
}

.submit-area-examples {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin: 10px;
}

.submit-area-example {
  cursor: pointer;
}

.submit-area-example:hover {
  opacity: 0.5;
}

.submit-area-buttons {
  /*
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  */
  font-size: 16px;
  margin-top: 30px;
  margin-bottom: 40px;
}

.submit-area-button {
  cursor: pointer;
  display: flex;
  flex-direction: column;
  align-items: center;
  /*
  margin: 30px 80px;
  */
}

.submit-area-button:hover {
  opacity: 0.5;
}

.submit-area-button-img {
  height: 65px;
  margin-bottom: 10px;
}

.submit-area-button-img img {
  height: 100%;
  width: auto;
}

.submit-area-button-name {
  height: 20px;
  line-height: 20px;
  font-weight: 600;
}

.intro {
  color: $font-grey;
  padding: 20px 0px;
}

.intro-title {
  font-size: 48px;
  text-align: center;
}

.intro-content {
  font-size: 20px;
  color: #212121;
}

</style>

